export default function AdGenerater(props) {
  const areaCheck = props.id;
  const bannerWidth = props.w ? props.w + 'px' : '300px';
  const bannerHeight = props.h ? props.h + 'px' : '100px';


  let srcUrl;

  if (areaCheck === 'top') {
    srcUrl = '/html/m/top.htm';
  } else if (areaCheck === 'middle') {
    srcUrl = '/html/m/middle.htm';
  } else if (areaCheck === 'live') {
    srcUrl = '/html/m/live.htm';
  } else if (areaCheck === '24live_mo_bottom_320_50') {
    srcUrl = '/html/m/24live_mo_bottom_320_50.htm';
  } else if (areaCheck === '24live_mo_middle_320_50') {
    srcUrl = '/html/m/24live_mo_middle_320_50.htm';
  } else if (areaCheck === '24live_mo_top_320_100') {
    srcUrl = '/html/m/24live_mo_top_320_100.htm';
  } else {
    srcUrl = '/html/m/bottom.htm';
  }

  if (areaCheck === 'live_listcontents_topAD') {
    return (
      <div className='live_listcontents_topAD'>
        <iframe title='배너광고' display='block' src='/html/m/24live_mo_top_320_100.htm' width={bannerWidth} height={bannerHeight} scrolling='no' frameBorder='0' align='middle' marginWidth='0' marginHeight='0' />
      </div>
    );
  }

  // * 2023 항저우아시안게임
  if (areaCheck === 'live_top_ag_2023') {
    return (
      <div className='bigEventBanner_w'>
        <div className='bigEventBannerTop_w'>
          <iframe title='배너광고' className="bigEventBanner_img" display='block' src='/html/m/live_top_ag_2023.htm' width='300px' height='100px' scrolling='no' frameBorder='0' marginWidth='0' marginHeight='0' align='middle' />
        </div>
      </div>
    );
  }

  // * 24tv 배너
  if (areaCheck === '24live_mo_top_320_100') {
    return (
      <div className='bigEventBanner_w'>
        <div className='bigEventBannerTop_w'>
          <iframe title='배너광고' display='block' src='/html/m/24live_mo_top_320_100.htm' width='320px' height='100px' scrolling='no' frameBorder='0' marginWidth='0' marginHeight='0' align='middle' />
        </div>
      </div>
    );
  } 

  return (
    <div className={areaCheck.indexOf('live') > -1 ? 'contents_area_ad' : 'main_contents_ad'}>
      <div className='ad_banner_w' style={{ width: bannerWidth, height: bannerHeight }}>
        <iframe title='배너광고' display='block' src={srcUrl} width={bannerWidth} height={bannerHeight} scrolling='no' frameBorder='0' marginWidth='0' marginHeight='0' align='middle' />
      </div>
    </div>
  );
}
